// extracted by mini-css-extract-plugin
export default {"fileName":"ClassEdit_fileName__y5qAY","deleteIcon":"ClassEdit_deleteIcon__OP+Zq"};